import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { isEmpty } from '../../utils/obj-utils';
import { domainConstants } from '../../utils/constants/domain-constants';

function Upcoming({
    upcomingTicket,
    noUpcomingEventText,
    ssoDomain,
    showParkingButton,
    showParkingButtonText,
    parkingButtonUrl,
    onViewTicketsClick
}) {
    function handleViewTicketsClick(event) {
        event.preventDefault();
        onViewTicketsClick(upcomingTicket);
    }

    function showParking() {
        return showParkingButton && (ssoDomain === domainConstants.theOpen);
    }

    return (
        <div className='upcoming'>
            <h2>{formMessageConstants.upcoming}</h2>
            {isEmpty(upcomingTicket) ?
                <div className='no-files'>
                    <p className='info'>{noUpcomingEventText}</p>
                </div> : <Fragment>
                    <svg
                        aria-hidden='true'
                        focusable='false'
                        data-prefix='far'
                        data-icon='calendar-alt'
                        role='img'
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 448 512'
                        className='icon-calendar'>
                        <path
                            fill='#2269AB'
                            d='M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z'
                            className=''>
                        </path>
                    </svg>
                    <div className='info'>
                        <p className='sub-title'>{upcomingTicket.productName}</p>
                        <p className='duration'>{upcomingTicket.detailsText}</p>
                        <p className='championship'>{upcomingTicket.eventName}</p>
                        <p className='location'>
                            <svg
                                aria-hidden='true'
                                focusable='false'
                                data-prefix='fas'
                                data-icon='map-marker-alt'
                                role='img'
                                xmlns='http://www.w3.org/2000/svg'
                                viewBox='0 0 384 512'
                                className='map-marker'>
                                <path
                                    fill='currentColor'
                                    d='M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z'
                                    className=''>
                                </path>
                            </svg>
                            <span>{upcomingTicket.eventLocation}</span>
                        </p>
                    </div>
                    <div className='buttons-container'>
                        <a className='yellow-button' onClick={handleViewTicketsClick}>{formMessageConstants.viewTickets}</a>
                        {showParking() && <a className='yellow-button' href={parkingButtonUrl}>{showParkingButtonText}</a>}
                        <p className='tickets-number'>
                            <svg
                                aria-hidden='true'
                                focusable='false'
                                data-prefix='far'
                                data-icon='ticket-alt'
                                role='img'
                                xmlns='http://www.w3.org/2000/svg'
                                viewBox='0 0 576 512'
                                className='ticket'>
                                <path
                                    fill='currentColor'
                                    d='M400 208v96H176v-96h224m24-48H152c-13.255 0-24 10.745-24 24v144c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24zm144 56h8V112c0-26.51-21.49-48-48-48H48C21.49 64 0 85.49 0 112v104h8c22.091 0 40 17.909 40 40s-17.909 40-40 40H0v104c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V296h-8c-22.091 0-40-17.909-40-40s17.909-40 40-40zm-40-38.372c-28.47 14.59-48 44.243-48 78.372s19.53 63.782 48 78.372V400H48v-65.628c28.471-14.59 48-44.243 48-78.372s-19.529-63.782-48-78.372V112h480v65.628z'
                                    className=''></path>
                            </svg>
                            <span>{`x ${upcomingTicket.quantity}`}</span>
                        </p>
                    </div>
                </Fragment>}
        </div>
    );
}

Upcoming.propTypes = {
    upcomingTicket: PropTypes.object,
    noUpcomingEventText: PropTypes.string.isRequired,
    onViewTicketsClick: PropTypes.func.isRequired,
};

export default Upcoming;
